'use strict';

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _require = require('buffer'),
    Buffer = _require.Buffer;

var _require2 = require('idb'),
    openDB = _require2.openDB,
    deleteDB = _require2.deleteDB;

var _require3 = require('interface-datastore'),
    Key = _require3.Key,
    Errors = _require3.Errors,
    utils = _require3.utils,
    Adapter = _require3.Adapter;

var filter = utils.filter,
    sortAll = utils.sortAll;

var isStrictTypedArray = function isStrictTypedArray(arr) {
  return arr instanceof Int8Array || arr instanceof Int16Array || arr instanceof Int32Array || arr instanceof Uint8Array || arr instanceof Uint8ClampedArray || arr instanceof Uint16Array || arr instanceof Uint32Array || arr instanceof Float32Array || arr instanceof Float64Array;
};

var typedarrayToBuffer = function typedarrayToBuffer(arr) {
  if (isStrictTypedArray(arr)) {
    // To avoid a copy, use the typed array's underlying ArrayBuffer to back new Buffer
    var buf = Buffer.from(arr.buffer);

    if (arr.byteLength !== arr.buffer.byteLength) {
      // Respect the "view", i.e. byteOffset and byteLength, without doing a copy
      buf = buf.slice(arr.byteOffset, arr.byteOffset + arr.byteLength);
    }

    return buf;
  } else {
    // Pass through all other types to `Buffer.from`
    return Buffer.from(arr);
  }
};

var str2ab = function str2ab(str) {
  var buf = new ArrayBuffer(str.length);
  var bufView = new Uint8Array(buf);

  for (var i = 0, strLen = str.length; i < strLen; i++) {
    bufView[i] = str.charCodeAt(i);
  }

  return buf;
};

var queryIt = /*#__PURE__*/function () {
  var _ref = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(q, store, location) {
    var range, cursor, limit, key, value;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            range = q.prefix ? self.IDBKeyRange.bound(str2ab(q.prefix), str2ab(q.prefix + '\xFF'), false, true) : undefined;
            _context.next = 3;
            return _awaitAsyncGenerator(store.transaction(location).store.openCursor(range));

          case 3:
            cursor = _context.sent;
            limit = 0;

            if (!(cursor && q.offset && q.offset > 0)) {
              _context.next = 9;
              break;
            }

            _context.next = 8;
            return _awaitAsyncGenerator(cursor.advance(q.offset));

          case 8:
            cursor = _context.sent;

          case 9:
            if (!cursor) {
              _context.next = 27;
              break;
            }

            if (!(q.limit !== undefined && q.limit === limit)) {
              _context.next = 12;
              break;
            }

            return _context.abrupt("return");

          case 12:
            limit++;
            key = new Key(Buffer.from(cursor.key));

            if (!q.keysOnly) {
              _context.next = 19;
              break;
            }

            _context.next = 17;
            return {
              key: key
            };

          case 17:
            _context.next = 22;
            break;

          case 19:
            value = Buffer.from(cursor.value);
            _context.next = 22;
            return {
              key: key,
              value: value
            };

          case 22:
            _context.next = 24;
            return _awaitAsyncGenerator(cursor.continue());

          case 24:
            cursor = _context.sent;
            _context.next = 9;
            break;

          case 27:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function queryIt(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var IdbDatastore = /*#__PURE__*/function (_Adapter) {
  _inherits(IdbDatastore, _Adapter);

  var _super = _createSuper(IdbDatastore);

  function IdbDatastore(location) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, IdbDatastore);

    _this = _super.call(this);
    _this.store = null;
    _this.options = options;
    _this.location = options.prefix + location;
    _this.version = options.version || 1;
    return _this;
  }

  _createClass(IdbDatastore, [{
    key: "open",
    value: function () {
      var _open = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var location;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(this.store !== null)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                location = this.location;
                _context2.prev = 3;
                _context2.next = 6;
                return openDB(this.location, this.version, {
                  upgrade: function upgrade(db) {
                    db.createObjectStore(location);
                  }
                });

              case 6:
                this.store = _context2.sent;
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](3);
                throw Errors.dbOpenFailedError(_context2.t0);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 9]]);
      }));

      function open() {
        return _open.apply(this, arguments);
      }

      return open;
    }()
  }, {
    key: "put",
    value: function () {
      var _put = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(key, val) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(this.store === null)) {
                  _context3.next = 2;
                  break;
                }

                throw new Error('Datastore needs to be opened.');

              case 2:
                _context3.prev = 2;
                _context3.next = 5;
                return this.store.put(this.location, val, key.toBuffer());

              case 5:
                _context3.next = 10;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](2);
                throw Errors.dbWriteFailedError(_context3.t0);

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[2, 7]]);
      }));

      function put(_x4, _x5) {
        return _put.apply(this, arguments);
      }

      return put;
    }()
  }, {
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(key) {
        var value;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(this.store === null)) {
                  _context4.next = 2;
                  break;
                }

                throw new Error('Datastore needs to be opened.');

              case 2:
                _context4.prev = 2;
                _context4.next = 5;
                return this.store.get(this.location, key.toBuffer());

              case 5:
                value = _context4.sent;
                _context4.next = 11;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](2);
                throw Errors.dbWriteFailedError(_context4.t0);

              case 11:
                if (value) {
                  _context4.next = 13;
                  break;
                }

                throw Errors.notFoundError();

              case 13:
                return _context4.abrupt("return", typedarrayToBuffer(value));

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[2, 8]]);
      }));

      function get(_x6) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: "has",
    value: function () {
      var _has = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(key) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(this.store === null)) {
                  _context5.next = 2;
                  break;
                }

                throw new Error('Datastore needs to be opened.');

              case 2:
                _context5.prev = 2;
                _context5.next = 5;
                return this.get(key);

              case 5:
                _context5.next = 12;
                break;

              case 7:
                _context5.prev = 7;
                _context5.t0 = _context5["catch"](2);

                if (!(_context5.t0.code === 'ERR_NOT_FOUND')) {
                  _context5.next = 11;
                  break;
                }

                return _context5.abrupt("return", false);

              case 11:
                throw _context5.t0;

              case 12:
                return _context5.abrupt("return", true);

              case 13:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[2, 7]]);
      }));

      function has(_x7) {
        return _has.apply(this, arguments);
      }

      return has;
    }()
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(key) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(this.store === null)) {
                  _context6.next = 2;
                  break;
                }

                throw new Error('Datastore needs to be opened.');

              case 2:
                _context6.prev = 2;
                _context6.next = 5;
                return this.store.delete(this.location, key.toBuffer());

              case 5:
                _context6.next = 10;
                break;

              case 7:
                _context6.prev = 7;
                _context6.t0 = _context6["catch"](2);
                throw Errors.dbDeleteFailedError(_context6.t0);

              case 10:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[2, 7]]);
      }));

      function _delete(_x8) {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
  }, {
    key: "batch",
    value: function batch() {
      var _this2 = this;

      var puts = [];
      var dels = [];
      return {
        put: function put(key, value) {
          puts.push([key.toBuffer(), value]);
        },
        delete: function _delete(key) {
          dels.push(key.toBuffer());
        },
        commit: function () {
          var _commit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
            var tx, store;
            return _regeneratorRuntime.wrap(function _callee7$(_context7) {
              while (1) {
                switch (_context7.prev = _context7.next) {
                  case 0:
                    if (!(_this2.store === null)) {
                      _context7.next = 2;
                      break;
                    }

                    throw new Error('Datastore needs to be opened.');

                  case 2:
                    tx = _this2.store.transaction(_this2.location, 'readwrite');
                    store = tx.store;
                    _context7.next = 6;
                    return Promise.all(puts.map(function (p) {
                      return store.put(p[1], p[0]);
                    }));

                  case 6:
                    _context7.next = 8;
                    return Promise.all(dels.map(function (p) {
                      return store.delete(p);
                    }));

                  case 8:
                    _context7.next = 10;
                    return tx.done;

                  case 10:
                  case "end":
                    return _context7.stop();
                }
              }
            }, _callee7);
          }));

          function commit() {
            return _commit.apply(this, arguments);
          }

          return commit;
        }()
      };
    }
  }, {
    key: "query",
    value: function query(q) {
      if (this.store === null) {
        throw new Error('Datastore needs to be opened.');
      }

      var it = queryIt(q, this.store, this.location);

      if (Array.isArray(q.filters)) {
        it = q.filters.reduce(function (it, f) {
          return filter(it, f);
        }, it);
      }

      if (Array.isArray(q.orders)) {
        it = q.orders.reduce(function (it, f) {
          return sortAll(it, f);
        }, it);
      }

      return it;
    }
  }, {
    key: "close",
    value: function close() {
      if (this.store === null) {
        throw new Error('Datastore needs to be opened.');
      }

      this.store.close();
      this.store = null;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      return deleteDB(this.location);
    }
  }]);

  return IdbDatastore;
}(Adapter);

module.exports = IdbDatastore;